<template>
  <v-dialog
    transition="slide-x-transition"
    content-class="custom-dialog"
    v-model="showDialog"
    scrollable
    @click:outside="onClose"
    width="500"
  >
    <v-card class="right">
      <!-- Header -->
      <div
        style="width: 100%; height: 64px; padding: 8px 16px; left: 0; top: 0; position: relative; box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.06); border-bottom: 1px #F2F2F2 solid; justify-content: flex-start; align-items: center; gap: 10px; display: inline-flex"
      >
        <v-card-text
          style="flex: 1 1 0; color: #404040; font-size: 20px; font-family: Rubik; font-weight: 500; line-height: 36px; word-wrap: break-word"
        >
          Nuevo descuento
        </v-card-text>

        <img
          src="@/assets/img/close.svg"
          type="button"
          @click="onClose"
          alt="Close"
        />
      </div>

      <div style="height: 100vh">
        <!-- Options -->
        <div
          style="width: 100%; padding: 16px; left: 0; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex"
        >
          <div style="width: 100%">
            <div class="title">
              Código
            </div>

            <v-text-field
              style="width: 100%; margin-top: 8px"
              label="Escribí un código"
              v-model="code"
              dense
              solo
              flat
              outlined
            />
          </div>

          <div style="width: 100%">
            <div class="title">
              Descuento
            </div>

            <v-text-field
              style="width: 100%; margin-top: 8px"
              label="Escribí el porcentaje de descuento"
              v-model="discount"
              :error-messages="
                discount > 100
                  ? 'El porcentaje no puede ser mayor a 100'
                  : discount != null && discount <= 0
                  ? 'El porcentaje debe ser mayor a 0'
                  : null
              "
              type="number"
              dense
              solo
              flat
              outlined
            />
          </div>

          <div style="width: 100%">
            <div class="title">
              Límite de usos
            </div>

            <v-text-field
              style="width: 100%; margin-top: 8px"
              label="Sin límite"
              v-model="limit"
              :error-messages="
                limit != null && limit <= 0
                  ? 'El limite debe ser mayor a 0'
                  : null
              "
              type="number"
              dense
              solo
              flat
              outlined
            />
          </div>

          <div style="width: 100%">
            <div class="title">
              Límite de citas por usuario
            </div>

            <v-text-field
              style="width: 100%; margin-top: 8px"
              label="Sin límite"
              v-model="appQuantityLimit"
              :error-messages="
                appQuantityLimit != null && appQuantityLimit <= 0
                  ? 'El límite debe ser mayor a 0'
                  : null
              "
              type="number"
              dense
              solo
              flat
              outlined
            />
          </div>

          <div style="width: 100%">
            <div class="title">
              Límite de citas con descuento por usuario
            </div>

            <v-text-field
              style="width: 100%; margin-top: 8px"
              label="Sin límite"
              v-model="appQuantityLimitWithDiscount"
              :error-messages="
                appQuantityLimit != null && appQuantityLimit <= 0
                  ? 'El límite debe ser mayor a 0'
                  : null
              "
              type="number"
              dense
              solo
              flat
              outlined
            />
          </div>
        </div>

        <!-- Footer -->
        <v-card-actions>
          <div
            style="width: 100%; background: white; justify-content: center; align-items: center; gap: 14px; display: inline-flex"
          >
            <v-btn
              @click="onClose"
              rounded
              variant="outlined"
              style="width: 44%; color: #404040; font-size: 16px; font-family: Plus Jakarta Sans; font-weight: 600; line-height: 24px; word-wrap: break-word; border: thin solid #595959; background: transparent;  text-transform: none;"
            >
              Cancelar
            </v-btn>

            <v-btn
              @click="onClickApply"
              rounded
              :disabled="!createButtonEnabled"
              :loading="loading"
              style="width: 44%; color: white; font-size: 16px; font-family: Plus Jakarta Sans; font-weight: 600; line-height: 24px; word-wrap: break-word; background: #F48020;  text-transform: none;"
            >
              Crear
            </v-btn>
          </div>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.right {
  position: absolute;
  width: 400px;
  top: 0;
  right: 0;
  margin: 0;
  min-height: 100%;
}

.title {
  color: #404040;
  font-size: 16px;
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
}
</style>

<script>

export default {
  name: "ModalFilter",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    code: null,
    discount: null,
    limit: null,
    appQuantityLimit: null,
    appQuantityLimitWithDiscount: null,
    createButtonEnabled: false,
    loading: false
  }),

  watch: {
    code() {
      this.updateCreateButton();
    },
    discount() {
      this.updateCreateButton();
    },
    limit() {
      this.updateCreateButton();
    },
    appQuantityLimit() {
      this.updateCreateButton();
    },
    appQuantityLimitWithDiscount() {
      this.updateCreateButton();
    }
  },

  methods: {
    updateCreateButton() {
      this.createButtonEnabled =
        this.code &&
        this.discount &&
        this.discount <= 100 &&
        this.discount > 0 &&
        (this.limit == null || this.limit > 0) &&
        (this.appQuantityLimit == null || this.appQuantityLimit > 0) &&
        (this.appQuantityLimitWithDiscount == null || this.appQuantityLimitWithDiscount > 0);
    },

    updateProfessionals() {
      this.$store
        .dispatch("Professionals/getListAll", {
          work_abroad:
            this.selectedPlatform?.value === "ars"
              ? "local"
              : this.selectedPlatform?.value === "usd"
              ? "abroad"
              : "all"
        })
        .then(response => {
          for (let professional of response) {
            this.professionalList.push({
              id: professional.id,
              name: professional.first_name + " " + professional.last_name
            });
          }
        });
    },

    onClose() {
      this.$emit("close");
      this.code = null;
      this.limit = null;
      this.discount = null;
      this.appQuantityLimit = null;
      this.appQuantityLimitWithDiscount = null;
    },

    async onClickApply() {
      //Request
      const request = { code: this.code, discount: this.discount };
      if (this.limit) {
        request.quantity_limit = this.limit;
      }

      if (this.appQuantityLimit) {
        request.app_quantity_limit = this.appQuantityLimit;
      }

      if (this.appQuantityLimitWithDiscount) {
        request.app_quantity_limit_with_discount = this.appQuantityLimitWithDiscount;
      }

      this.loading = true;
      await this.$store.dispatch("Discounts/create", request);
      this.loading = false;

      this.$emit("created");
      this.onClose();
    }
  }
};
</script>
